import { render, staticRenderFns } from "./user-bookcourse-review.vue?vue&type=template&id=619c9c36&scoped=true"
import script from "./user-bookcourse-review.vue?vue&type=script&lang=js"
export * from "./user-bookcourse-review.vue?vue&type=script&lang=js"
import style0 from "./user-bookcourse-review.vue?vue&type=style&index=0&id=619c9c36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619c9c36",
  null
  
)

export default component.exports